




















































import { defineComponent, ref, reactive } from '@vue/composition-api'
import { useQuery, useResult } from '@vue/apollo-composable'
import usersQuery from '@/lib/graphql/users.query.gql'
import { useRouter } from '@u3u/vue-hooks'
import UserAvatar from '@/components/UserAvatar.vue'
import MemberStatusBadge from '@/components/MemberStatusBadge.vue'
import { toDateString, numberWithCommas } from '@/lib/utils'

export default defineComponent({
  components: {
    UserAvatar,
    MemberStatusBadge
  },

  setup(_, { root }) {
    const { route, router } = useRouter()
    const pageSize = 10
    const current = +(route.value.query['current'] ?? 1)
    const searchTerm = ref(route.value.query['q'] as string)

    const predicateFunc = (q?: string) => {
      if (!q) {
        return undefined
      }

      return isUUID(q)
        ? { id: { _eq: q } }
        : {
            _or: [
              { email: { _like: `%${q}%` } },
              {
                name: {
                  _like: `%${q}%`
                }
              }
            ]
          }
    }
    const params = reactive({
      offset: (current - 1) * pageSize,
      limit: pageSize,
      where: predicateFunc(searchTerm.value) || undefined
    })

    const { result, loading, onError, refetch } = useQuery(usersQuery, params, {
      debounce: 300
    })
    const data = useResult(result, { users: [], pagination: {} }, data => {
      const users = data.users
      const pagination = {
        total: data.users_aggregate.aggregate.count,
        pageSize,
        current: params.offset / params.limit + 1
      }
      return {
        // eslint-disable-next-line
        users: users.map((u: any) => ({
          ...u,
          insertedAt: toDateString(new Date(u.inserted_at))
        })),
        pagination
      }
    })
    onError(error => {
      console.error(error)
      root.$notification.error({
        message: 'Error',
        description: 'An error occurred'
      })
    })

    const columns = [
      {
        title: '',
        dataIndex: 'avatar',
        scopedSlots: { customRender: 'avatar' },
        align: 'center'
      },
      {
        title: 'id',
        dataIndex: 'id'
      },
      {
        title: 'name',
        dataIndex: 'name'
      },
      {
        title: 'email',
        dataIndex: 'email'
      },
      {
        title: 'language',
        dataIndex: 'locale'
      },
      {
        title: 'status',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' }
      },
      {
        title: 'joined at',
        dataIndex: 'insertedAt'
      }
    ]

    const search = () => {
      params.offset = 0
      router.push({
        path: route.value.path,
        query: { ...route.value.query, current: undefined, q: searchTerm.value }
      })
      params.where = predicateFunc(searchTerm.value)
      refetch()
    }

    const handleTableChange = ({
      pageSize,
      current
    }: {
      pageSize: number
      current: number
    }) =>
      // filters: any,
      // sorter: { field: string; order: string }
      {
        router.push({
          path: route.value.path,
          query: { ...route.value.query, current: `${current}` }
        })
        params.offset = (current - 1) * pageSize
        refetch()
      }

    return {
      searchTerm,

      handleTableChange,

      numberWithCommas,

      search,

      loading,
      data,
      columns
    }
  }
})

const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
function isUUID(val?: string) {
  return val?.match(regex) ?? false
}
